import react from "react";

const Page404 = () => {
    return (
        <h2>404 Not Found</h2>
    )
}

export default Page404